import React, { useEffect, useRef } from "react";
import { personalInfo } from "../../data/portfolio";

/**
 * Local time where the work happens. Writes straight to the node once a second
 * so the bar never re-renders for a tick.
 */
const Clock = ({ className = "" }) => {
  const out = useRef(null);

  useEffect(() => {
    const paint = () => {
      if (!out.current) return;
      out.current.textContent = new Date().toLocaleTimeString("en-GB", {
        timeZone: personalInfo.timeZone,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
    };

    paint();
    const id = window.setInterval(paint, 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <span className={className}>
      {personalInfo.location} <span ref={out} className="t-num">00:00:00</span> IST
    </span>
  );
};

export default Clock;
